module.exports = __webpack_public_path__ + "static/img/manage5-bg.10a4bc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/manage5-bg.png
// module id = B1qf
// module chunks = 0